import {Component, OnInit} from '@angular/core';
import {OrganizzazioniService} from '../../../_services/organizzazioni.service';
import {ModalController} from '@ionic/angular';
import {SaveMessage} from '../../../_helpers/save-message';
import {Movimento} from '../../../_models/Movimento';
import {MovimentiService} from '../../../_services/movimenti.service';
import {constants} from '../../../_helpers/constants';
import {AuthenticationService} from "../../../_services/authentication.service";
import {LicenzeService} from "../../../_services/licenze.service";

const emptyMovimento: Movimento = {
  organizzazioneId: 0,
  id: 0,
  dataUnixRegistrazione: 0,
  idRigaMateriale: 0,
  codArt: '',
  unitaMisura: '',
  quantita: 0,
  coeffX1: 1,
  codLottoAlfa: '',
  contesto: 0,
  tipoMovimento: 0,
  prezzo: 0
};

@Component({
    selector: 'app-movimenti-create',
    templateUrl: './movimenti-create.component.html',
    styleUrls: ['./movimenti-create.component.scss'],
    standalone: false
})
export class MovimentiCreateComponent  implements OnInit {
  movimento: Movimento;
  isNew = true;
  loading = false;
  protected readonly constants = constants;
  constructor(
    public authService: AuthenticationService,
    public licenseService: LicenzeService,
    private organizzazioniService: OrganizzazioniService,
    private movimentiService: MovimentiService,
    private modalCtrl: ModalController,
    private saveMessage: SaveMessage) { }

  ngOnInit() {
    if (this.movimento == null) {
      this.movimento = emptyMovimento;
      this.movimento.organizzazioneId = this.organizzazioniService.organizzazioneId;
      this.movimento.dataUnixRegistrazione = Math.floor(new Date().getTime() / 1000);
    }

    if (this.movimento.prezzo == null) {
      this.movimento.prezzo = 0;
    }
  }

  confirm() {
    if (this.movimento.codArt === '') {
      this.saveMessage.messageError("Codice articolo non valido.");
      return false;
    }
    this.loading = true;
    if (this.isNew) {
      this.movimentiService.createMovimentoAsync(this.movimento)
        .then(this.succesSave)
        .catch(this.errorSave)
        .finally(() => this.loading = false);
    } else {
      this.movimentiService.updateMovimentoAsync(this.movimento)
        .then(this.succesSave)
        .catch(this.errorSave)
        .finally(() => this.loading = false);
    }
  }

  succesSave = (_movimento: Movimento) => {
    this.saveMessage.messageInfo('Operazione eseguita con successo.');
    this.modalCtrl.dismiss(this.movimento, 'confirm');
  };

  errorSave = () => this.saveMessage.messageError("Ci sono problemi con il salvataggio.");

  cancel = () =>  this.modalCtrl.dismiss(false, 'cancel');
}
